<template>
    <div class="mt-11" v-if="visibleChannels != 0">
        <div class="mb-2 text-2lg font-bold text-center">
            Add {{ title }}
        </div>
        <div class="grid grid-cols-1 tablet:grid-cols-2 widescreen:grid-cols-3 gap-4">
            <div v-for="(channel, key) in visibleChannels" :key="key" class="card-gray flex flex-col justify-between rounded shadow py-4 px-3">
                <div>
                    <!--{{channel.name}}-->
                    <AdditionalChannelsImage
                        :channelName="channel.name"
                    />
                </div>
                <div class="flex justify-between items-center content-center">
                    <PricePerMonth
                        size="small"
                        :price="channel.price"
                    />
                    <div class="justify-self-end
                                col-span-2 desktop:col-span-1
                                text-center">
                        <button
                            @click="$emit('select-package', channel)"
                            :class="{ 'active': isPackageSelected(channel) }"
                            :disabled="!hasSelectedAService"
                            class="buyflow-button flex items-center"
                        >
                            <template v-if="isPackageSelected(channel)">
                                <IconCheck class="inline mr-1" />
                                Added
                            </template>
                            <template v-else>
                                <span v-if="!hasSelectedAService">
                                    Package required
                                </span>
                                <span v-else>
                                    <IconPlus class="inline mr-1" />
                                    Add
                                </span>
                            </template>
                        </button>
                    </div>
                </div>
            </div>
        </div>
            <div
                v-if="!showAllChannels && this.channels.length > 3"
                @click.prevent="showAllChannels = true"
                class="mt-2 mx-auto py-2 text-xs desktop:text-sm flex items-center justify-center text-center text-navy-dark w-max hover:underline whitespace-nowrap"
            >
                See More {{ title }} <IconCaretDown class="inline ml-1" />
            </div>
    </div>
</template>

<script>
import PricePerMonth from "@/atoms/PricePerMonth"
import IconCaretDown from "@/atoms/icons/IconCaretDown"
import IconCheck from "@/atoms/icons/IconCheck"
import IconPlus from "@/atoms/icons/IconPlus"
import IconCircleExclamation from "@/atoms/icons/IconCircleExclamation"
import AdditionalChannelsImage from './AdditionalChannelsImage.vue'
export default {
    name: 'TVAdditionalChannelsCards',
    components: {
        IconCaretDown,
        IconCheck,
        IconPlus,
        PricePerMonth,
        AdditionalChannelsImage,
        IconCircleExclamation
    },
    props: {
        title: {
            type: String,
            required: true,
            default: 'Additional Channels',
        },
        channels: {
            type: Array,
            required: true,
            default: () => ([]),
        },
        isPackageSelected: {
            type: Function,
            required: true,
        },
        hasSelectedAService: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        showAllChannels: false,
    }),
    computed: {
        visibleChannels() {
            return this.showAllChannels ? this.channels : this.channels.slice(0, 3)
        },
    },
    mounted() {
        // if there's at least one channel already selected, do not even collapse this
        if (this.channels.some(this.isPackageSelected)) {
            this.showAllChannels = true
        }
    },
}
</script>

<style scoped>
    .card-gray {
        background: #F9F9F9;
    }
</style>
